import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Radio, X } from "lucide-react";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";

export const LiveBanner = () => {
  const { t } = useT();
  const [s, setS] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const load = () => api.get("/settings").then((r) => setS(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);

  const on = s?.live?.on && s?.socials?.tiktok && !hidden;

  return (
    <AnimatePresence>
      {on && (
        <motion.div data-testid="live-banner" initial={{ y: -60, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -60, opacity: 0 }}
          className="fixed top-16 inset-x-0 z-40 bg-[#1FD1FF] text-black shadow-[0_0_30px_rgba(31,209,255,0.5)]">
          <div className="max-w-[1500px] mx-auto px-4 lg:px-10 py-2.5 flex items-center gap-3">
            <span className="relative flex w-3 h-3 shrink-0"><span className="absolute inset-0 rounded-full bg-black/70 animate-ping" /><span className="relative w-3 h-3 rounded-full bg-black" /></span>
            <Radio className="w-4 h-4 shrink-0 hidden sm:block" />
            <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.15em] font-bold truncate">
              <span className="sm:hidden">{t("live.short")}</span><span className="hidden sm:inline">{t("live.banner")}</span>{s.live.message ? <span className="font-normal normal-case tracking-normal hidden sm:inline"> · {s.live.message}</span> : null}
            </p>
            <a href={s.socials.tiktok} target="_blank" rel="noopener noreferrer" data-testid="live-banner-join"
              className="ml-auto shrink-0 px-3 sm:px-4 py-1.5 bg-black text-[#1FD1FF] font-mono text-xs uppercase tracking-widest hover:bg-white hover:text-black transition-colors">
              {t("live.join")} ↗
            </a>
            <button data-testid="live-banner-close" onClick={() => setHidden(true)} aria-label={t("live.close")} className="p-1 hover:opacity-60"><X className="w-4 h-4" /></button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
